import { cn } from "@/lib/utils";
import { TONE_STYLES, type Tone } from "@/lib/colors";
import { COMMISSION_STATUS_LABELS } from "@shared/labels";
import type { CommissionStatus } from "@shared/schema";

const COMMISSION_TONE: Record<CommissionStatus, Tone> = {
  en_attente_retractation: "yellow",
  du: "coral",
  paye: "green",
  annule: "slate",
};

export function CommissionPill({
  status,
  className,
}: {
  status: CommissionStatus;
  className?: string;
}) {
  const tone = TONE_STYLES[COMMISSION_TONE[status]];
  return (
    <span className={cn("pill", tone.pillBg, tone.pillFg, className)}>
      <span className={cn("pill-dot", tone.dot)} />
      {COMMISSION_STATUS_LABELS[status]}
    </span>
  );
}
